<h3 mat-dialog-title i18n="@@core.attribute-list.filter-on">Filter on {{getColumnName()}}</h3>
<div (keydown.enter)="onOk()">

  <tm-attribute-filter [attributeType]="getAttributeType()"
                       [filter]="filter"
                       [uniqueValues$]="uniqueValues$"
                       (filterChanged)="updateFilter($event)"></tm-attribute-filter>

  <mat-dialog-actions>

    <button mat-raised-button
            color="primary"
            [disabled]="!isValidFilter()"
            (click)="onOk()" i18n="@@core.common.set">Set</button>
    <button mat-raised-button color="primary"
            (click)="onClear()" i18n="@@core.common.clear">Clear</button>
    <button mat-raised-button color="primary"
            (click)="onCancel()" i18n="@@core.common.cancel">Cancel</button>
  </mat-dialog-actions>

</div>
